import { ParsedField } from '@aeppic/forms-parser'

export function lookupDefaultControlName(field: ParsedField) {
  return field.subType
}
